import React from "react";
import TestimonialCard from "./TestimonialCard";

type testimonialSliderProps = {
  items: any;
  withSlide?: boolean;
};

const TestimonialSlider = ({ items, withSlide = true }: testimonialSliderProps) => {
  return (
    <React.Fragment>
      {withSlide ? (
        <div className="container">
          <div className="slider-container">
            {items.map((item: any, index: number) => {
              return (
                <div key={index}>
                  <TestimonialCard img={item.img} name={item.name} message={item.message} title={item.title} />
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div>
          <div>
            {items.map((item: any, index: number) => {
              return (
                <div key={index}>
                  <TestimonialCard
                    img={item.img}
                    name={item.name}
                    message={item.message}
                    title={item.title}
                    inSlide={withSlide}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}

      <style jsx>{`
        .container {
          display: flex;
          flex-direction: row !important;
          align-items: center;
          width: 100%;
          height: 240px;
          overflow-x: scroll;
        }
        .slider-container {
          width: auto;
          display: flex;
          margin: 0 12px;
        }
        ::-webkit-scrollbar {
          height: 5px;
        }
        ::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3);
          border-radius: 8px;
        }
        ::-webkit-scrollbar-thumb {
          border-radius: 8px;
          -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
        }
        @media only screen and (max-width: 910px) {
          .container {
            border-radius: 0px;
            height: 320px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default TestimonialSlider;
